export enum UserRoles {
    Administrator = "administrator",
    Biller = "biller",
    Operator = "operator",
    SellerOperator = "seller-operator",
    Support = "support",
}
